import type { Dispatch, SetStateAction } from "react";
import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

interface ResetPasswordResult {
  redirect_url: string;
}
interface ResetPasswordProps {
  options?: UseMutationOptions<any, unknown, any, unknown>;
  setIsResettingPassword: Dispatch<SetStateAction<boolean>>;
}

interface RequestBody {
  user: {
    password: string;
    password_confirmation: string;
    email: string;
  };
}

export const useResetPassword = ({
  setIsResettingPassword,
  options = {},
}: ResetPasswordProps) => {
  const toast = useToast();

  return useMutation(
    (body: RequestBody) => {
      setIsResettingPassword(true);
      return reactQueryPost(
        authenticationAppRoutes.resetPasswordOnOtpLogin(),
        body,
      );
    },
    {
      onSuccess: (data: ResetPasswordResult) => {
        window.location.href = data?.redirect_url;
        toast.success("Password reset successfully.");
      },
      onError: (error: any) => {
        setIsResettingPassword(false);
        console.error(error);
        toast.error(error.message);
      },
      ...options,
    },
  );
};
